import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import "react-lazy-load-image-component/src/effects/blur.css";

import { Story } from "@/shared/types/common";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getImageByPriority } from "@/shared/utils/common";

export default function SectionStoriesSlider({
  slides,
  loading,
  showStory,
}: {
  slides: Story[];
  loading?: boolean;
  showStory: (index: number) => void;
}) {
  return (
    <div className="overflow-hidden relative z-10">
      {!loading ? (
        <Swiper
          className="!container !overflow-visible"
          modules={[Navigation]}
          spaceBetween={8}
          slidesPerView="auto"
        >
          {slides?.map((slide, index) => (
            <SwiperSlide
              key={slide.id}
              className={`!w-[84px] !h-[90px] rounded-2xl p-px ${
                slide.is_seen ? "bg-white/20" : "bg-yellow-linear"
              }`}
            >
              <div
                className="relative !w-[82px] !h-[88px] overflow-hidden rounded-[15px] bg-[#21212D] p-[3px] cursor-pointer"
                onClick={() => showStory(index)}
              >
                <button className="w-[76px] h-[82px] text-start overflow-hidden rounded-xl">
                  <div className="w-full relative h-full rounded-xl flex items-end p-1.5">
                    <div className="bg-gradient-to-b from-dark/20 to-dark/90 absolute size-full left-0 top-0 z-20" />
                    <LazyLoadImage
                      src={getImageByPriority(slide.image, "medium")}
                      visibleByDefault
                      wrapperProps={{
                        style: { transitionDelay: "0.01s", zIndex: 10 },
                      }}
                      className="w-full absolute top-0 z-10 left-0 h-full object-cover"
                    />
                    <p className="text-white relative z-[21] text-small leading-130 font-medium line-clamp-2 break-words overflow-hidden">
                      {slide.name}
                    </p>
                  </div>
                </button>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <Swiper
          className="!container !overflow-visible"
          modules={[Navigation]}
          spaceBetween={8}
          slidesPerView="auto"
        >
          {Array.from({ length: 4 }).map((_, idx) => (
            <SwiperSlide
              key={idx}
              className="!w-[84px] aspect-[84/90] rounded-2xl p-px bg-white/20"
            >
              <div className="relative !w-[82px] aspect-[84/90] overflow-hidden rounded-[15px] bg-[#21212D] p-[3px] cursor-pointer">
                <div className="w-[76px] aspect-[84/90] skeleton rounded-xl"></div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
}
